export default "__VITE_ASSET__Cwirv3KD__"